import { Text, View } from '@react-pdf/renderer'
import React from 'react'

interface SectionHeaderProps {
  title: string
}

export const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => {
  return (
    <View
      style={{
        backgroundColor: '#4B5563',
        padding: 10,
        marginTop: 20,
        marginBottom: 10,
      }}>
      <Text
        style={{
          color: 'white',
          fontSize: 14,
          fontWeight: 700,
        }}>
        {title}
      </Text>
    </View>
  )
}
